import type { OnetimePayReviewComponentType } from '@/src/experiences/card-payments/screens/OnetimePayReview'
import { useMutation } from '@apollo/client'
import { graphql } from '@api/mesa'
import { GET_CREDIT_CARD_INFORMATION } from '@/src/common/gql/queries/card'
import * as CardActivity from '@/src/experiences/card-activity'

export const LegacyOnetimePayReview = ((props) => {
  const {
    logError,
    alertPaymentProcessingError,
    onetimePaymentStore: { account, paymentAmount, paymentDate },
  } = props

  const [createOneTimePayment, { loading }] = useMutation(
    graphql(`
      mutation CreateOneTimePayment(
        $highnoteExternalAccountId: String!
        $consentTimestamp: String!
        $paymentAmount: String!
        $transferDate: String!
      ) {
        createOneTimePaymentV2(
          highnoteExternalAccountId: $highnoteExternalAccountId
          consentTimestamp: $consentTimestamp
          paymentAmount: $paymentAmount
          transferDate: $transferDate
        ) {
          __typename
          ... on MesaUserError {
            message
          }
        }
      }
    `),
    {
      fetchPolicy: 'no-cache',
      async onQueryUpdated(observableQuery) {
        await new Promise((resolve) => setTimeout(resolve, 888))
        await observableQuery.refetch()
      },
      onCompleted({ createOneTimePaymentV2 }) {
        createOneTimePaymentV2.__typename === 'MesaUserError'
          ? alertPaymentProcessingError(createOneTimePaymentV2.message)
          : props.onSuccess()
      },
      onError: props.onError,
      refetchQueries: [
        CardActivity.Components.Highnote.ScheduledTransfers.GET_INCOMING_SCHEDULED_TRANSFERS,
        // this probably doesn't need to be refetched since this mutation is only a scheduling, not an immediate payment.
        // still though let's refresh just in case
        GET_CREDIT_CARD_INFORMATION,
      ],
    },
  )

  return (
    <props.OnetimePayReviewComponent
      {...props}
      loading={loading}
      createOneTimePayment={() => {
        if (!account?.highnoteExternalAccountId || !paymentAmount || !paymentDate) {
          logError('Missing fields for the payment', { account, paymentAmount, paymentDate })
          alertPaymentProcessingError()
          return
        }

        void createOneTimePayment({
          variables: {
            highnoteExternalAccountId: account.highnoteExternalAccountId,
            consentTimestamp: new Date(paymentDate).toISOString(),
            paymentAmount: (parseFloat(paymentAmount) / 100).toFixed(2).toString(),
            transferDate: new Date(paymentDate).toISOString(),
          },
        })
      }}
    />
  )
}) satisfies OnetimePayReviewComponentType
